import { ErpOrder, ErpOrderSchema, Order } from '../schema'

export const OrderTransform = {
  toErp: (order: Order): ErpOrder => ({
    ...order,
    localId: undefined,
    variable_values: undefined,
  }),
  // What the ERP ends up with: `toErp` plus the strip and coercions of the schema
  toErpPayload: (order: Order): ErpOrder => {
    const erp = OrderTransform.toErp(order)
    const parsed = ErpOrderSchema.safeParse(erp)
    if (!parsed.success) {
      // Invalid orders are rejected by the same schema on the way in, keep them
      // unstripped so they still read as changed and the request surfaces the error
      return erp
    }
    return parsed.data
  },
  fromErp: (
    order: ErpOrder | Order,
    { localId, variable_values }: Pick<Order, 'localId' | 'variable_values'>
  ): Order => ({
    ...order,
    localId,
    variable_values,
  }),
}
